import edReCoreText from "./Ed_ReCore.SC2Hotkeys" with { type: "text" };
import type { SC2Source } from "./source";

/**
 * The Edennil Source's SC2 setup: the maintainer's own `.SC2Hotkeys`, shipped as
 * content - never an upload. It is board-bound to the ReCore board's SC2 layer: the
 * file is character-space, so selecting it pins ReCore + `recore-v3-layer-5` and the existing
 * parse-through-the-active-lens recovers faithful positions (digits that the layer emits from two
 * keys are deduped to the maintainer's gaming-cluster key). Not a CatalogEntry: board-bound means
 * no locale switch/download, so it carries no Preset route - it is a plain selectable source.
 */
export const EDENNIL_SC2_SOURCE: SC2Source = {
  id: "edennil-sc2",
  name: "Edennil (ReCore)",
  text: edReCoreText,
  pin: { keyboard: "recore-v3", layer: "recore-v3-layer-5" },
};
